import { FlowExtractPtBr } from "./flow-extract-pt-br";

export const FLOW_EXTRACT_ES_MX: FlowExtractPtBr = {
	table: {
		description: "Descripción",
		initialValue: "Saldo Inicial:",
		finalValue: "Saldo Final:",
		in: "Total de Entrada:",
		out: "Total de Salida:",
		value: "Valor",
		item: {
			liquidationDate: "FECHA DE LIQUIDACIÓN",
			referenceDate: "FECHA DE REFERENCIA",
			type: "TIPO",
			originDestination: "ORIGEN/DESTINO",
			category: "CATEGORÍA",
			observation: "OBSERVACIÓN",
			value: "VALOR",
		},
	},
	excel: {
		title: "Informe de Extracto",
		grouped: {
			day: "por día",
			month: "por mes",
			type: "por tipo",
			category: "por categoría",
		},
	},
	search: "Buscar por...",
	yesterday: "Ayer",
	today: "Hoy",
	filter: {
		perType: "Por Tipo",
	},
	accountRequired: "Se requiere una cuenta.",
	anticipated: "Anticipado",
	normalValue: "Valor Normal",
	anticipatedValue: "Valor Anticipado",
};
